// Importless policy shared by server first paint and client hydration.
export type EffectsMode = 'auto' | 'full' | 'reduced' | 'off';
export type ResolvedEffectsMode = Exclude<EffectsMode, 'auto'>;
export const EFFECTS_STORAGE_KEY = 'elowen:effects';
export const DEFAULT_EFFECTS_MODE: EffectsMode = 'auto';

export function isEffectsMode(value: string | null): value is EffectsMode {
  return value === 'auto' || value === 'full' || value === 'reduced' || value === 'off';
}

export function resolveEffectsMode(mode: EffectsMode, systemReduced: boolean): ResolvedEffectsMode {
  return mode === 'auto' ? (systemReduced ? 'reduced' : 'full') : mode;
}

/** The inline script embeds the same policy functions and constants, before React hydrates. */
export const NO_FLASH_EFFECTS = `(function(){
  var isEffectsMode = ${isEffectsMode.toString()};
  var resolveEffectsMode = ${resolveEffectsMode.toString()};
  var mode = ${JSON.stringify(DEFAULT_EFFECTS_MODE)};
  try {
    var stored = localStorage.getItem(${JSON.stringify(EFFECTS_STORAGE_KEY)});
    if (isEffectsMode(stored)) mode = stored;
  } catch {}
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.setAttribute('data-effects-mode', mode);
  document.documentElement.setAttribute('data-effects', resolveEffectsMode(mode, reduced));
})();`;
